/* Quopener thema: kleine, afhankelijkheidsvrije scripts. Alles werkt ook zonder JS, dit maakt het prettiger. */
(() => {
  document.documentElement.classList.add('js');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const live = document.querySelector('[data-live-region]');
  const announce = (msg) => { if (!live) return; live.textContent = ''; setTimeout(() => { live.textContent = msg; }, 50); };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Teksten uit de taalbestanden (layout/theme.liquid zet window.QuopenerStrings) ----------
     Ontbreekt een tekst, dan valt hij terug op het Nederlands. */
  const STR = window.QuopenerStrings || {};
  const tr = (key, fallback, vars) => {
    let s = typeof STR[key] === 'string' && STR[key] ? STR[key] : fallback;
    if (vars) Object.keys(vars).forEach((k) => { s = s.split(`[${k}]`).join(vars[k]); });
    return s;
  };
  const lang = String(STR.locale || document.documentElement.lang || 'nl').toLowerCase();
  const isEn = lang.slice(0, 2) === 'en';

  /* ---------- Onthullen bij scrollen (hiërarchie, geen versiering) ---------- */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Hero-video ----------
     Eerst een lichte poster (snelle LCP). De video laadt pas als de pagina klaar is: 480p op mobiel, 720p op desktop.
     Speelt zonder geluid, pauzeert buiten beeld. Bij reduced motion pas laden na een klik. */
  document.querySelectorAll('[data-hero-video]').forEach((wrap) => {
    const video = wrap.querySelector('video');
    const playBtn = wrap.querySelector('[data-video-play]');
    const soundBtn = wrap.querySelector('[data-video-sound]');
    const soundLabel = wrap.querySelector('[data-sound-label]');
    let loaded = false;
    let inView = true;
    video.muted = true;
    const load = () => {
      if (loaded) return;
      loaded = true;
      const small = window.matchMedia('(max-width: 899px)').matches;
      video.src = (small && video.dataset.srcSm) || video.dataset.src || video.dataset.srcSm;
      video.preload = 'auto';
    };
    const tryPlay = () => {
      load();
      video.play().then(() => { playBtn.hidden = true; }).catch(() => { playBtn.hidden = false; });
    };
    video.addEventListener('playing', () => wrap.classList.add('is-playing'));
    if (reduceMotion) {
      playBtn.hidden = false;
    } else {
      const start = () => {
        const go = () => { if (inView && !wrap.dataset.paused) tryPlay(); };
        if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 600);
      };
      if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          inView = entry.isIntersecting;
          if (!loaded) return;
          if (inView) { if (!wrap.dataset.paused) tryPlay(); } else { video.pause(); }
        }, { threshold: 0.35 }).observe(wrap);
      }
    }
    playBtn.addEventListener('click', () => { delete wrap.dataset.paused; tryPlay(); });
    video.addEventListener('click', () => {
      if (video.paused) { delete wrap.dataset.paused; tryPlay(); } else { wrap.dataset.paused = '1'; video.pause(); playBtn.hidden = false; }
    });
    soundBtn.addEventListener('click', () => {
      video.muted = !video.muted;
      if (!video.muted) tryPlay();
      soundBtn.setAttribute('aria-pressed', String(!video.muted));
      soundLabel.textContent = video.muted ? tr('soundOn', 'Geluid aan') : tr('soundOff', 'Geluid uit');
    });
  });

  /* ---------- Aanbiedingsbalk: handmatig bladeren op mobiel, geen autoplay ---------- */
  document.querySelectorAll('[data-announcement]').forEach((bar) => {
    const items = [...bar.querySelectorAll('.announcement__item')];
    if (items.length < 2) return;
    let i = 0;
    const show = (n) => { items[i].classList.remove('is-active'); i = (n + items.length) % items.length; items[i].classList.add('is-active'); };
    bar.querySelector('[data-announcement-prev]')?.addEventListener('click', () => show(i - 1));
    bar.querySelector('[data-announcement-next]')?.addEventListener('click', () => show(i + 1));
  });

  /* ---------- Mobiel menu: sluiten met Escape ---------- */
  const menu = document.querySelector('[data-mobile-menu]');
  menu?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });

  /* ---------- Horizontale scrollers (reviews) ---------- */
  document.querySelectorAll('[data-scroller-root]').forEach((wrap) => {
    const track = wrap.querySelector('[data-scroller]');
    if (!track) return;
    const prev = wrap.querySelector('[data-scroller-prev]');
    const next = wrap.querySelector('[data-scroller-next]');

    /* Eindeloze carrousel: één kaart tegelijk, "volgende" na de laatste toont weer de eerste. */
    if (wrap.hasAttribute('data-scroller-loop')) {
      const slides = [...track.children];
      if (slides.length < 2) return;
      let i = 0;
      track.classList.add('is-cycle');
      const show = (n, dir) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => {
          const on = k === i;
          s.classList.toggle('is-active', on);
          s.classList.toggle('from-left', on && dir < 0);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
      };
      prev?.addEventListener('click', () => show(i - 1, -1));
      next?.addEventListener('click', () => show(i + 1, 1));
      let x0 = null;
      track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') show(i + 1, 1);
        if (e.key === 'ArrowLeft') show(i - 1, -1);
      });
      show(0, 1);
      return;
    }

    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 300) + 20;
    const count = wrap.querySelector('[data-scroller-count]');
    const update = () => {
      if (count) {
        const total = track.children.length;
        const perView = Math.max(1, Math.round(track.clientWidth / step()));
        const first = Math.min(total, Math.round(track.scrollLeft / step()) + 1);
        const last = Math.min(total, first + perView - 1);
        count.textContent = last > first ? `${first}–${last} / ${total}` : `${first} / ${total}`;
      }
      if (loop) return;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    const loop = wrap.hasAttribute('data-scroller-loop');
    const atStart = () => track.scrollLeft <= 4;
    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    const behavior = reduceMotion ? 'auto' : 'smooth';
    /* Eindeloos: bij "volgende" schuift de eerste kaart achteraan, bij "vorige" de laatste vooraan.
       Zo loopt de rij altijd door en spring je nooit terug naar het begin. */
    let busy = false;
    const settle = (fn) => {
      let done = false;
      const finish = () => { if (done) return; done = true; track.removeEventListener('scrollend', finish); fn(); busy = false; };
      track.addEventListener('scrollend', finish);
      setTimeout(finish, reduceMotion ? 30 : 650);
    };
    const jump = (left) => { track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; track.scrollTo({ left, behavior: 'instant' }); track.offsetHeight; track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; };
    prev?.addEventListener('click', () => {
      if (!loop) { track.scrollBy({ left: -step(), behavior }); return; }
      if (busy) return; busy = true;
      if (atStart()) {
        track.prepend(track.lastElementChild);
        jump(track.scrollLeft + step());
      }
      requestAnimationFrame(() => track.scrollBy({ left: -step(), behavior }));
      settle(() => {});
    });
    next?.addEventListener('click', () => {
      if (!loop) { track.scrollBy({ left: step(), behavior }); return; }
      if (busy) return; busy = true;
      if (atEnd()) {
        track.append(track.firstElementChild);
        jump(track.scrollLeft - step());
      }
      requestAnimationFrame(() => track.scrollBy({ left: step(), behavior }));
      settle(() => {});
    });
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
  });

  /* ---------- Productgalerij ---------- */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...track.children];
    const count = gallery.querySelector('[data-gallery-count]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumbs] button')];
    if (slides.length < 2) { gallery.querySelector('.gallery__controls')?.setAttribute('hidden', ''); return; }
    let current = 0;
    const go = (n) => {
      current = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const mark = () => {
      if (count) count.textContent = tr('counter', '[index] van [count]', { index: current + 1, count: slides.length });
      thumbs.forEach((t, i) => t.setAttribute('aria-current', i === current ? 'true' : 'false'));
      slides.forEach((s, i) => { if (i !== current) s.querySelector('video')?.pause(); });
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > 0.6) { current = slides.indexOf(e.target); mark(); } });
    }, { root: track, threshold: [0.6] });
    slides.forEach((s) => io.observe(s));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(current + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.index))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    mark();
  });

  /* ---------- Winkelmand ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  let lastFocus = null;
  const SECTIONS = 'cart-drawer';

  const renderCart = (sections) => {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    ['[data-cart-body]', '[data-cart-foot]'].forEach((sel) => {
      const fresh = doc.querySelector(sel);
      document.querySelectorAll(sel).forEach((el) => {
        if (!fresh) return;
        el.innerHTML = fresh.innerHTML;
        el.hidden = fresh.hidden;
      });
    });
    const n = Number(doc.querySelector('[data-cart-count-source]')?.textContent || 0);
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.hidden = n === 0;
      badge.innerHTML = `${n}<span class="visually-hidden"> ${n === 1 ? tr('itemOne', 'artikel') : tr('itemOther', 'artikelen')}</span>`;
    });
  };

  const openDrawer = () => {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => drawer.querySelector('.drawer__panel')?.focus(), 50);
    return true;
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus?.focus();
  };

  document.querySelectorAll('[data-cart-toggle]').forEach((el) => el.addEventListener('click', (e) => {
    if (document.body.classList.contains('template-cart')) return;
    if (openDrawer()) e.preventDefault();
  }));
  drawer?.addEventListener('click', (e) => { if (e.target.closest('[data-cart-close]')) closeDrawer(); });
  document.addEventListener('keydown', (e) => {
    if (!drawer?.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab') {
      const f = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden])')].filter((el) => el.offsetParent !== null && !el.classList.contains('drawer__overlay'));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  const cartRequest = async (url, body) => {
    const res = await fetch(`${root}${url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: SECTIONS, sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'cart');
    return data;
  };

  const addItems = async (items) => {
    const data = await cartRequest('cart/add.js', { items });
    renderCart(data.sections);
    return data;
  };

  // Aantal wijzigen en verwijderen (lade en winkelmandpagina)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line][data-qty]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try {
      const data = await cartRequest('cart/change.js', { line: Number(btn.dataset.line), quantity: Number(btn.dataset.qty) });
      renderCart(data.sections);
      announce(document.querySelector('[data-cart-body]') ? tr('cartUpdated', 'Winkelmand bijgewerkt.') : '');
      if (document.body.classList.contains('template-cart') && data.item_count === 0) window.location.reload();
    } catch (err) { window.location.href = `${root}cart`; }
  });

  // Cross sell: de andere kleur toevoegen, de automatische korting maakt er de bundel van
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-crosssell]');
    if (!form) return;
    e.preventDefault();
    const id = Number(form.querySelector('[name=id]').value);
    try {
      await addItems([{ id, quantity: 1 }]);
      announce(tr('added', 'Staat in je winkelmand.'));
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (err) { form.submit(); }
  });

  /* ---------- Koopkeuze: aantal en kleur per Quopener ----------
     1 of 2: per Quopener een kleur. "Meer dan 2": per kleur zelf het aantal, elk aantal vanaf 1. */
  /* Nederlands: €1.234,50. Engels: €1,234.50. */
  const euro = (cents, trim) => {
    const dec = isEn ? '.' : ',';
    const grp = isEn ? ',' : '.';
    const [whole, frac] = (cents / 100).toFixed(2).split('.');
    const s = `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, grp)}${dec}${frac}`;
    return `€${trim && frac === '00' ? s.slice(0, -3) : s}`;
  };

  document.querySelectorAll('[data-buy-form]').forEach((form) => {
    const qtyRadios = [...form.querySelectorAll('input[name=qty]')];
    const units = [...form.querySelectorAll('[data-unit]')];
    const unitsWrap = form.querySelector('[data-units]');
    const mix = form.querySelector('[data-mix]');
    const mixInputs = mix ? [...mix.querySelectorAll('.mix__qty')] : [];
    const mixNote = mix && mix.querySelector('[data-mix-note]');
    const unitCents = Number(form.dataset.unitCents);
    const tierCents = Number(form.dataset.tierCents);
    const priceNow = form.querySelector('[data-price-current]');
    const priceWas = form.querySelector('[data-price-compare]');
    const priceWasValue = form.querySelector('[data-price-compare-value]');
    const priceSave = form.querySelector('[data-price-save]');
    const status = form.querySelector('[data-buy-status]');
    const submit = form.querySelector('[data-buy-submit]');
    const stickyBar = document.querySelector('[data-sticky-buy]');
    const sticky = stickyBar && stickyBar.dataset.form === form.id ? stickyBar.querySelector('[data-sticky-price]') : null;

    const isMix = () => { const r = qtyRadios.find((x) => x.checked); return r && r.value === 'mix'; };
    const qtyOf = (input) => Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
    const mixTotal = () => mixInputs.filter((i) => !i.disabled).reduce((t, i) => t + qtyOf(i), 0);

    const showPrice = (total, full, save) => {
      if (priceNow) priceNow.textContent = total;
      if (priceWas) { priceWas.hidden = !full; if (priceWasValue) priceWasValue.textContent = full; }
      if (priceSave) { priceSave.hidden = !save; priceSave.textContent = save; }
      if (sticky) sticky.textContent = total;
    };

    const syncMix = () => {
      const n = mixTotal();
      mixInputs.forEach((i) => {
        const v = qtyOf(i);
        const box = i.closest('.mix__item');
        box.classList.toggle('is-zero', v === 0);
        box.querySelector('[data-step="-1"]').disabled = i.disabled || v === 0;
        box.querySelector('[data-step="1"]').disabled = i.disabled || v >= 99;
      });
      const ok = n >= 1;
      if (mixNote) {
        mixNote.textContent = !ok ? mix.dataset.textMin : n === 1 ? mix.dataset.textOne : mix.dataset.textTotal.replace('[n]', n);
        mixNote.classList.toggle('is-warn', !ok);
      }
      if (ok) {
        const total = (n >= 2 ? tierCents : unitCents) * n;
        const full = unitCents * n;
        const save = full - total;
        showPrice(euro(total), save > 0 ? euro(full) : '', save > 0 ? tr('youSave', 'je bespaart [amount]', { amount: euro(save, true) }) : '');
      }
      return ok;
    };

    const sync = () => {
      const r = qtyRadios.find((x) => x.checked);
      if (!r) return;
      const many = r.value === 'mix';
      const n = many ? 0 : Number(r.value);
      units.forEach((u) => {
        const on = !many && Number(u.dataset.unit) <= n;
        u.hidden = !on;
        u.disabled = !on;
      });
      if (unitsWrap) unitsWrap.hidden = many;
      if (mix) { mix.hidden = !many; mix.disabled = !many; }
      if (many) { syncMix(); return; }
      showPrice(r.dataset.total, r.dataset.full, r.dataset.save);
    };
    qtyRadios.forEach((r) => r.addEventListener('change', () => { status.textContent = ''; sync(); }));

    if (mix) {
      mix.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-step]');
        if (!btn) return;
        const input = btn.closest('.mix__item').querySelector('.mix__qty');
        input.value = Math.max(0, Math.min(99, qtyOf(input) + Number(btn.dataset.step)));
        syncMix();
      });
      mixInputs.forEach((i) => {
        i.addEventListener('input', syncMix);
        i.addEventListener('change', () => { i.value = qtyOf(i); syncMix(); });
      });
    }
    sync();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      let items = [];
      if (!qtyRadios.some((x) => x.checked)) {
        status.textContent = tr('chooseQty', 'Kies eerst hoeveel Quopeners je wilt.');
        qtyRadios[0].closest('fieldset').scrollIntoView({ behavior: 'smooth', block: 'center' });
        qtyRadios[0].focus({ preventScroll: true });
        return;
      }
      if (isMix()) {
        if (!syncMix()) { status.textContent = mix.dataset.textMin; return; }
        items = mixInputs.filter((i) => !i.disabled && qtyOf(i) > 0)
          .map((i) => ({ id: Number(i.closest('.mix__item').querySelector('input[type=hidden]').value), quantity: qtyOf(i) }));
      } else {
        const counts = new Map();
        let missing = false;
        units.filter((u) => !u.disabled).forEach((u) => {
          const c = u.querySelector('input[type=radio]:checked');
          if (!c) { missing = true; return; }
          counts.set(c.value, (counts.get(c.value) || 0) + 1);
        });
        if (missing || counts.size === 0) {
          status.textContent = tr('chooseColorEach', 'Kies voor elke Quopener een kleur.');
          return;
        }
        items = [...counts].map(([id, quantity]) => ({ id: Number(id), quantity }));
      }
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        await addItems(items);
        if (form.dataset.mode === 'checkout') {
          status.textContent = tr('toCheckout', 'Even geduld, je gaat naar afrekenen.');
          window.location.href = `${root}checkout`;
          return;
        }
        status.textContent = tr('added', 'Staat in je winkelmand.');
        openDrawer();
      } catch (err) {
        status.textContent = err.message && err.message !== 'cart' ? err.message : tr('error', 'Er ging iets mis. Probeer het nog eens.');
      } finally {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
  });

  /* ---------- Sticky koopbalk op mobiel ----------
     Zichtbaar zolang geen enkel koopformulier op de pagina in beeld is. */
  const stickyBar = document.querySelector('[data-sticky-buy]');
  const buyForms = [...document.querySelectorAll('[data-buy-form], [data-sticky-anchor]')];
  if (stickyBar && buyForms.length && 'IntersectionObserver' in window) {
    const visible = new Set();
    const submitBtn = stickyBar.querySelector('[data-sticky-submit]');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      const show = visible.size === 0;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      submitBtn.tabIndex = show ? 0 : -1;
    }, { threshold: 0.25 });
    buyForms.forEach((f) => io.observe(f.querySelector('[data-buy-submit]') || f));
    if (submitBtn.tagName === 'BUTTON') submitBtn.addEventListener('click', () => {
      document.getElementById(stickyBar.dataset.form)?.requestSubmit();
    });
  }

  /* ---------- Korte video's in "Het verschil": zonder geluid, alleen in beeld ----------
     Laadt pas als de video bijna in beeld is. Bij prefers-reduced-motion blijft de poster staan. */
  const autoVids = [...document.querySelectorAll('video[data-autoplay-src]')];
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (autoVids.length && !calm && 'IntersectionObserver' in window) {
    const vio = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) {
          if (!v.src) { v.src = v.dataset.autoplaySrc; v.preload = 'auto'; }
          v.muted = true;
          const p = v.play(); if (p && p.catch) p.catch(() => {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.35 });
    autoVids.forEach((v) => vio.observe(v));
  }

  /* ---------- Servicebalk: berichten wisselen, één tegelijk ---------- */
  document.querySelectorAll('[data-announcement]').forEach((bar) => {
    const items = [...bar.querySelectorAll('.announcement__item')];
    if (items.length < 2) return;
    bar.classList.add('is-rotating');
    const wait = Math.max(3, Number(bar.dataset.interval) || 4) * 1000;
    let i = 0;
    let paused = false;
    items.forEach((it, k) => it.setAttribute('aria-hidden', k === 0 ? 'false' : 'true'));
    const tick = () => {
      if (paused || document.hidden) return;
      items[i].classList.remove('is-active'); items[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active'); items[i].setAttribute('aria-hidden', 'false');
    };
    setInterval(tick, wait);
    bar.addEventListener('mouseenter', () => { paused = true; });
    bar.addEventListener('mouseleave', () => { paused = false; });
    bar.addEventListener('focusin', () => { paused = true; });
    bar.addEventListener('focusout', () => { paused = false; });
  });

  /* ---------- Focus op formulierbevestiging na herladen ---------- */
  document.querySelector('[data-focus-on-load]')?.focus();

  /* ---------- Cookiebanner via de Shopify Customer Privacy API ---------- */
  const banner = document.querySelector('[data-cookie-banner]');
  const setConsent = (all) => {
    const consent = { analytics: all, marketing: all, preferences: all, sale_of_data: all };
    window.Shopify?.customerPrivacy?.setTrackingConsent(consent, () => { if (banner) banner.hidden = true; });
    if (!window.Shopify?.customerPrivacy && banner) banner.hidden = true;
  };
  const initPrivacy = () => {
    const api = window.Shopify?.customerPrivacy;
    if (!api || !banner) return;
    const needed = typeof api.shouldShowBanner === 'function' ? api.shouldShowBanner() : true;
    const given = typeof api.getTrackingConsent === 'function' ? api.getTrackingConsent() !== 'no_interaction' : false;
    if (needed && !given) banner.hidden = false;
  };
  if (banner) {
    banner.querySelector('[data-cookie-accept]').addEventListener('click', () => setConsent(true));
    banner.querySelector('[data-cookie-decline]').addEventListener('click', () => setConsent(false));
    document.querySelectorAll('[data-cookie-open]').forEach((b) => b.addEventListener('click', () => { banner.hidden = false; banner.querySelector('button').focus(); }));
    const load = () => window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => { if (!error) initPrivacy(); }
    );
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') load();
    else window.addEventListener('load', () => { if (window.Shopify?.loadFeatures) load(); });
    document.addEventListener('visitorConsentCollected', () => { banner.hidden = true; });
  }
})();
